import { render } from "./MyGym.vue?vue&type=template&id=01063880&scoped=true"
import script from "./MyGym.vue?vue&type=script&lang=js"
export * from "./MyGym.vue?vue&type=script&lang=js"

import "./MyGym.vue?vue&type=style&index=0&id=01063880&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01063880"]])

export default __exports__